module.exports = __webpack_public_path__ + "28be371937632361e31e1c7c93435cd5.pdf";